export enum ImageMode {
    Pad = 'pad',
    Crop = 'crop',
    None = 'none'
}